module.exports = __webpack_public_path__ + "img/horizontal_6_7_pp3_7005.b811c7de.png";